import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import { IConfirmDashDonation } from '@nkr/models/index';
import { TableWrapper } from '../styles';
import { Modal, Button, Alert } from 'react-bootstrap';
import Row from './row';

interface IItem {
    id: number,
    confirmChecked: boolean,
    denyChecked: boolean,
    surgeryCompletedDateTime: string,
    valid: boolean
}

interface IProps {
    show: boolean,
    items: IConfirmDashDonation[],
    onConfirm: (list: { id: number, surgeryCompletedDateTime: string, confirmed: boolean }[]) => void,
    onClose: () => void,
}

interface IState {
    list: IItem[]
}

class ConfirmDashDonations extends React.Component<IProps, IState> {
    readonly state: IState = {
        list: []
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.show) {
            let list = nextProps.items.map(x => {
                return {
                    id: x.id,
                    confirmChecked: false,
                    denyChecked: false,
                    surgeryCompletedDateTime: x.surgeryCompletedDateTime,
                    valid: true
                }
            });

            this.setState({
                list
            });
        }
    }

    handleSave = () => {
        let list = this.validate();
        let isValid = list.filter(x => x.valid);

        this.setState({
            list
        }, () => {
            if (list.length == isValid.length) {          
                let list = this.state.list.filter(x => x.confirmChecked || x.denyChecked).map(x => 
                    { 
                        let confirmed = false;
                        if (x.confirmChecked == true)
                            confirmed = true;
                        return { id: x.id, surgeryCompletedDateTime: x.surgeryCompletedDateTime, confirmed: confirmed }; 
                    });
                this.props.onConfirm(list);
            }
        });
    }

    surgeryCompletedDateTimeChange = (id: number, value: string) => {
        let list = _.cloneDeep(this.state.list).map(item => {
            if (item.id == id) {
                item.surgeryCompletedDateTime = value;
            }

            return item;
        });

        this.setState({
            list
        });
    }

    checkedConfirmedChange = (id: number) => {
        let list = _.cloneDeep(this.state.list).map(item => {
            if (item.id == id) {
                item.confirmChecked = !item.confirmChecked;
                item.denyChecked = !item.confirmChecked;
            }

            return item;
        });

        this.setState({
            list
        });
    }

    checkedDenyChange = (id: number) => {
        let list = _.cloneDeep(this.state.list).map(item => {
            if (item.id == id) {
                item.denyChecked = !item.denyChecked;
                item.confirmChecked = !item.denyChecked;
            }

            return item;
        });

        this.setState({
            list
        });
    }

    validate = () => {
        let list = _.cloneDeep(this.state.list).map(item => {
            if (item.confirmChecked || item.denyChecked) {
                item.valid = moment(item.surgeryCompletedDateTime, 'MM/DD/YYYY', true).isValid()
            }

            return item;
        });

        return list;
    }

    render = () => {
        const allValid = this.state.list.filter(x => x.valid == false).length == 0;
        const disableSubmit = this.state.list.filter(x => x.confirmChecked || x.denyChecked).length == 0;

        return (
            <Modal show={this.props.show} bsSize='lg' backdrop='static' onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>OTHER - Confirm DASH Donations</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {!allValid && (
                        <Alert bsStyle='danger'>
                            Please check the surgery dates below...
                        </Alert>
                    )}

                    <TableWrapper className='table table-condensed table-striped table-bordered'>
                        <thead>
                            <tr style={{ backgroundColor: '#ddd' }}>
                                <th></th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th style={{ width: '25%' }}>Surgery Completed Date</th>
                                <th>Confirmed</th>
                                <th>Denied</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.items.map((item, index) => {
                                let currentItem = this.state.list.find(x => x.id == item.id);
                                let { confirmChecked, denyChecked, valid } = currentItem;

                                return (
                                    <Row
                                        key={index}
                                        data={item}
                                        isConfirmChecked={confirmChecked}
                                        isDenyChecked={denyChecked}
                                        valid={valid}
                                        onSurgeryCompletedDateTimeChange={this.surgeryCompletedDateTimeChange}
                                        onConfirmChecked={this.checkedConfirmedChange}
                                        onDenyChecked={this.checkedDenyChange}
                                    />
                                );
                            })}
                        </tbody>
                    </TableWrapper>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" disabled={disableSubmit} onClick={this.handleSave}>Submit</Button>
                    <Button onClick={this.props.onClose}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ConfirmDashDonations;